import { createSlice } from '@reduxjs/toolkit';
import { fetchAssetDowntimeAndShutdownData } from '../../dispatchers/ShutdownDispatcher';

interface AssetState {
  data?: any;
  loading: boolean;
  error?: string;
  lastFetchedParams?: string;
}

const initialState: AssetState = {
  data: undefined,
  loading: false,
  error: undefined,
  lastFetchedParams: undefined,
};

const ShutdownAndDropdownSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = undefined;
      state.error = undefined;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssetDowntimeAndShutdownData.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetDowntimeAndShutdownData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        const params = action.meta.arg;
        state.lastFetchedParams = `${params.assetId}|${params.startDate}|${params.endDate}|${params.popDate}`;
      })
      .addCase(fetchAssetDowntimeAndShutdownData.rejected, (state, action) => {
        state.loading = false;
        state.data = undefined;
        state.error = action.error.message || 'Something went wrong';
        console.error('Error fetching data:', state.error);
      });
  },
});

export const { setInitialState } = ShutdownAndDropdownSlice.actions;
export default ShutdownAndDropdownSlice.reducer;
